
import SpacesEditView from "../events/spaces/spaces-edit.html";

angular.module("spaces")

    .controller("SpacesListCtrl", ['$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', 'generateDocumentService', 'logService',
        function ($rootScope, $scope, $http, $interval, $q, i18nService, Restangular, gridService, modalService, $uibModal, $filter, $translate, generateDocumentService, logService) {
        
        $rootScope.title = $filter('translate')('spaces.title');
        logService.debug($filter('translate')('spaces.title'));
        $rootScope.breadcrumb = [
            { title: $filter('translate')('spaces.title') }
        ];

        $scope.gridOptionsSpaces = {
            pdfTitle: "Espacios",
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            enableSorting: true,            
            paginationPageSizes: [20, 40, 60],
            paginationPageSize: 20,
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
              { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
              { name: 'name', displayName: $filter('translate')('spaces.name'), enableFiltering: true, enableHiding: false },
              {
                  name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: $filter('translate')('spaces.button_preview'), action: 'ng-click="grid.appScope.openImage(row.entity.id)"', cssIconClass: "fa fa-image" },
                      { title: $filter('translate')('general.button_print'), action: 'ng-click="grid.appScope.printDialog(\'SPACE_FULL_PLAN\',row.entity.id)"', cssIconClass: "fa fa-file" },
                      { title: $filter('translate')('general.button_duplicate'), action: 'ng-click="grid.appScope.duplicate(row.entity.id)"', cssIconClass: "fa fa-copy" },
                      { title: $filter('translate')('general.button_edit'), action: 'ng-click="grid.appScope.openDesigner(row.entity.id);"', cssIconClass: "fa fa-edit" },
                      { title: $filter('translate')('general.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);"', cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right" })
              },
            ],
            getData: function (options) {             
                return Restangular.all('Spaces').getList(options)
            }
        };


        $scope.deleteDialog = function (id, name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('spaces.delete'),
                message: $filter('translate')('spaces.delete_message')+" " + $scope.name + "?",
                onAccept: function () {
                    Restangular.one('Spaces', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('spaces.delete_success'));
                        $scope.gridOptionsSpaces.gridApi.core.raise.itemDeleted($scope);
                        
                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };

        $scope.duplicate = function (id) {
            Restangular.all('Spaces').customPOST({}, "DuplicateSpace", { id: id }).then(function (result) {
                if (angular.isDefined(result.id)) {
                    toastr.success($filter('translate')('spaces.create_success'));
                    $scope.gridOptionsSpaces.loadData();
                } else {
                    $scope.errorMessage = result.message;
                }
            });
        }

        $scope.openImage = function (uid) {
            window.open('/api/spaces/' + uid + '/image', '_blank');
        };


        $scope.openDesigner = function (id) {
            logService.debug("Open", id);
            var modalInstance = $uibModal.open({
                template: SpacesEditView,
                controller: "EventsSpacesEditCtrl",
                size: "fullscreen",
                scope: $scope,
                backdrop: 'static',
                resolve: {
                    id: function () {
                        return id;
                    },
                    configuration: function () {
                        return "";
                    },
                    name: function () {
                        return "";
                    }
                }
            });
            modalInstance.result.then(function (options) {
                logService.debug(options);
                $scope.gridOptionsSpaces.loadData();
            }, function () {
                //dimissed
            });
        }

        $scope.printDialog = function (code, event_space_id) {
            var options = {
                code: "SPACE_GENERAL"
            }
            Restangular.all('Documents').getList(options).then(function (result) {

                if (angular.isDefined(result[0].id)) {
                    $http({
                        method: 'post',
                        url: (window as any).CONFIG.api_url + 'documentgenerator/Generate',
                        params: { document_id: result[0].id, space_id: event_space_id, outputType: 'pdf' }

                    }).then(function (result, status, headers, config) {
                        var url = (window as any).CONFIG.api_url + 'documentgenerator/download/' + result.data;
                        console.log(url);
                        window.open(url, '_blank');
                    });
                }
            });
        }

        
    }])

;